<template>

  <div class="w-table-wrap" style="max-height: 900px;">
    <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
  <w-card title-class="blue-dark4--bg white" style="font-size: 11px;" :title="'SENARAI KES'" >
      <template #title>
            SENARAI KES
            <w-flex justify-end class="mt2">
               <w-button @click="isMinimizedList = !isMinimizedList">
                  <template v-if="isMinimizedList">
                     <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                  </template>
                  <template v-else>
                     <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                  </template>
               </w-button>
            </w-flex>
        </template>
      <div v-show="!isMinimizedList">
      <div class="w-table-wrap" style="max-height: 1400px;" >
      <div class="table-profil-scrol">
        <table class="w-table" color="light" >
          <thead>
            <tr>
              <th class="w-table__header  text-center" width="1%">BIL</th>
              <th class="w-table__header  text-center">ID / NAMA TERNAKAN</th>
              <th class="w-table__header  text-center">KAEDAH SINKRONISASI</th>
            </tr>
          </thead>
           <tbody>
            <template v-if="ternakan_sinkronisasi.length == 0">
              <tr class="w-table__row" >
                <td class="w-table__cell text-center" colspan="5"> Tiada Data.</td>
              </tr>
            </template>
            <template v-for="(dt, ind) in ternakan_sinkronisasi">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" >{{ind+1}}</td>
                <td class="w-table__cell text-left" style="margin:3px;"><div style="width: 210px"></div>{{dt.ternakan_nama}}</td>
                <td class="w-table__cell text-left">
                <template v-if="dt.sinkronisasi.length < 4">
                  <w-tooltip md top color="white" bg-color="black" v-if="datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27">
                  <!-- <w-tooltip md top color="white" bg-color="black"> -->
                    <template #activator="{ on }">
                      <w-button dark class="green--bg ml1" v-on="on" @click="add(dt.id, dt)"><div style="width: 6px"></div> 
                        <w-icon class="mr1" md >fal fa-plus</w-icon>
                    </w-button>
                    </template>
                    TAMBAH 
                  </w-tooltip>
                </template>
                  <br>
                  <template v-for="(d, ind) in dt.sinkronisasi">
                     {{ind+1}}.
                     <w-tag class="mr4" style="color: #234781;" lg>
                       <template v-if="d.lkp_jenis_hormon_id == 3">
                        <w-tag
                             class="mr4"
                             bg-color="primary"
                             round v-if="d.sinkronisasi_ya_tidak==1 || d.sinkronisasi_ya_tidak==2">
                              <template v-if="d.sinkronisasi_ya_tidak==1">Berbayar</template>
                              <template v-else-if="d.sinkronisasi_ya_tidak==2">Subsidi</template>
                           </w-tag> {{d.hormon}} :
                        {{d.nama_hormon}} {{d.jenis_hormon}}
                         ({{$zutil.dateformat(d.tarikh_hormon)}})
                         {{d.kuantiti_hormon}}(ml)
                       </template>
                       <template v-else>
                        <w-tag
                             class="mr4"
                             bg-color="primary"
                             round v-if="d.sinkronisasi_ya_tidak==1 || d.sinkronisasi_ya_tidak==2">
                              <template v-if="d.sinkronisasi_ya_tidak==1">Berbayar</template>
                              <template v-else-if="d.sinkronisasi_ya_tidak==2">Subsidi</template>
                           </w-tag> {{d.hormon}} : {{d.jenis_hormon}} {{d.nama_hormon}}
                          ({{$zutil.dateformat(d.tarikh_masuk_suntik)}} - {{$zutil.dateformat(d.tarikh_keluar_suntik)}})
                       </template>
                       RM {{$zutil.currency(d.harga)}}
                       <w-tooltip md top color="white" bg-color="black" v-if="datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27">
                          <template #activator="{ on }">
                            <w-button dark class="warning--bg ml1" v-on="on" @click="edit(d, dt)"><div style="width: 6px"></div> 
                              <w-icon class="mr1" md >fal fa-pencil</w-icon>
                            </w-button>
                          </template>
                         KEMASKINI 
                      </w-tooltip>
                      <w-tooltip md top color="white" bg-color="black" v-if="datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27">
                          <template #activator="{ on }">
                            <w-button dark class="error--bg ml1" v-on="on" @click="remove(d)"><div style="width: 6px"></div> 
                              <w-icon class="mr1" md >fal fa-trash</w-icon>
                            </w-button>
                          </template>
                         PADAM 
                      </w-tooltip>
                     </w-tag><br>
                  </template>
                  
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      </div>
    </div>
  </w-card><br>
  <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'CAJ PERKHIDMATAN SINKRONISASI'" >
        <template #title>
        CAJ PERKHIDMATAN SINKRONISASI
        <w-flex justify-end class="mt2">
           <w-button @click="isMinimizedCaj = !isMinimizedCaj">
              <template v-if="isMinimizedCaj">
                 <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
              </template>
              <template v-else>
                 <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
              </template>
           </w-button>
        </w-flex>
    </template>
    <div v-show="!isMinimizedCaj">
         <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table width="100%">
                <tbody>
                  <tr class="row_data">
                     <td width="1%"><b>1.</b></td>
                     <td width="22%"><b>Konsultasi / Perkhidmatan</b></td>
                     <td width="1%"><b>:</b></td>
                     <td width="20%">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <w-radios
                             :items="ya_tidak"
                             v-model="datas.konsutasi_sinkronisasi_ya_tidak"
                             @input="kiraan_caj(datas)"
                             inline class="mr2"
                             :validators="[validators.required]"
                             >
                           </w-radios>
                        </div>
                        <div v-else>
                           <w-tag
                             class="mr4"
                             bg-color="primary"
                             round>
                              <template v-if="datas.konsutasi_sinkronisasi_ya_tidak==1">Berbayar</template><template v-else>Subsidi</template>
                           </w-tag>
                        </div>
                     </td>
                     <td width="1%"><b></b></td>
                     <td width="24%" align="right">
                     </td>
                     <td width="31%" align="right">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                            <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.konsutasi_sinkronisasi" @input="kiraan_caj(datas)"  outline/>
                        </div>
                        <div v-else>
                           RM {{$zutil.formatDecimal(datas.konsutasi_sinkronisasi)}}
                        </div>
                        
                     </td>
                  </tr>
                  </tbody>
               </table>
            </div>
            <div class="mx2"></div>
         </div>

         <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
            <table class="w-table" color="light" width="100%">
              <thead>
                <tr>
                  <td width="2%"><b>2. </b></td>
                  <td align="left" width="45%"><b>Harga Hormon</b></td>
                  <td align="center" width="20%"><b>Harga (RM)</b></td>
                  <td align="center" width="13%"><b>Kuantiti</b></td>
                  <td align="center" width="20%"><b>Jumlah (RM)</b></td>
                </tr>
              </thead>
              <tbody>
                  <tr>
                     <td></td>
                     <td align="left"><b>i. Hormon CIDR </b></td>
                     <td align="right">
                        <w-tag
                             class="mr4"
                             bg-color="primary"
                             round v-if="cidr.sinkronisasi_ya_tidak==1 || cidr.sinkronisasi_ya_tidak==2">
                              <template v-if="cidr.sinkronisasi_ya_tidak==1">Berbayar</template>
                              <template v-else-if="cidr.sinkronisasi_ya_tidak==2">Subsidi</template>
                           </w-tag>
                       {{$zutil.formatDecimal(cidr.harga)}}
                     </td>
                     <td class="w-table__cell text-center" align="center">
                       {{cidr.kuantiti}}
                     </td>
                     <td class="w-table__cell text-right" align="right">
                       {{$zutil.formatDecimal(cidr.jumlah)}}
                     </td>
                  </tr>
                  <tr>
                     <td></td>
                     <td><b>ii. Hormon Prid Delta</b></td>
                     <td align="right">
                        <w-tag
                             class="mr4"
                             bg-color="primary"
                             round v-if="prid_delta.sinkronisasi_ya_tidak==1 || prid_delta.sinkronisasi_ya_tidak==2">
                              <template v-if="prid_delta.sinkronisasi_ya_tidak==1">Berbayar</template>
                              <template v-else-if="prid_delta.sinkronisasi_ya_tidak==2">Subsidi</template>
                           </w-tag>
                       {{$zutil.formatDecimal(prid_delta.harga)}}
                     </td>
                     <td class="w-table__cell text-center" align="center">
                       {{prid_delta.kuantiti}}
                     </td>
                     <td class="w-table__cell text-right" align="right">
                       {{$zutil.formatDecimal(prid_delta.jumlah)}}
                     </td>
                  </tr>
                  <tr>
                     <td></td>
                     <td><b>iii. Hormon Tambahan</b></td>
                     <td align="right">
                        
                       
                        <w-tag
                             class="mr4"
                             bg-color="primary"
                             round v-if=" sinkronisasi_ya_tidak_subsidi > 0">
                              Subsidi
                        </w-tag>
                        <template v-if=" harga_persendirian_subsidi > 0">
                           {{$zutil.formatDecimal(harga_persendirian_subsidi)}}
                           <br>
                        </template>
                        <template v-else>
                            <template v-if=" sinkronisasi_ya_tidak_subsidi > 0">
                                0.00
                                <br>
                            </template>
                        </template>

                        <w-tag
                             class="mr4"
                             bg-color="primary"
                             round v-if=" sinkronisasi_ya_tidak_bayar > 0">
                              Berbayar
                        </w-tag>
                        <template v-if=" harga_persendirian_bayar > 0">
                           {{$zutil.formatDecimal(harga_persendirian_bayar)}}
                           <br>
                        </template>
                        <template v-else>
                            <template v-if="sinkronisasi_ya_tidak_bayar > 0">
                                0.00
                                <br>
                            </template>
                        </template>
                     </td>
                     <td class="w-table__cell text-center" align="center">
                        <template v-if=" sinkronisasi_ya_tidak_subsidi > 0">
                            -
                           <br>
                        </template>
                        <template v-if="sinkronisasi_ya_tidak_bayar > 0">
                            -
                           <br>
                        </template>
                     </td>
                     <td class="w-table__cell text-right" align="right">
                      <!-- {{$zutil.formatDecimal(jumlah_persendirian)}} -->

                        <template v-if=" jumlah_persendirian_subsidi > 0">
                           {{$zutil.formatDecimal(jumlah_persendirian_subsidi)}}
                           <br>
                        </template>
                         <template v-else>
                            <template v-if=" sinkronisasi_ya_tidak_subsidi > 0">
                                0.00
                                <br>
                            </template>
                        </template>
                        <template v-if=" jumlah_persendirian_bayar > 0">
                           {{$zutil.formatDecimal(jumlah_persendirian_bayar)}}
                           <br>
                        </template>
                         <template v-else>
                            <template v-if="sinkronisasi_ya_tidak_bayar > 0">
                                0.00
                                <br>
                            </template>
                        </template>
                     </td>
                  </tr>
              </tbody>
            </table>
            </div>
         </div>
         <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table width="100%">
                <tbody>
                  <tr class="row_data">
                     <td width="1%"><b>3.</b></td>
                     <td width="22%"><b>Caj Perjalanan (RM)</b></td>
                     <td width="1%"><b>:</b></td>
                     <td width="20%">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                          <w-radios
                             :items="ya_tidak"
                             v-model="datas.bayar_pengangkutan"
                             @input="kiraan_caj(datas)"
                             inline class="mr2"
                             :validators="[validators.required]"
                             >
                           </w-radios>
                        </div>
                        <div v-else>
                           <w-tag
                             class="mr4"
                             bg-color="primary"
                             round>
                              <template v-if="datas.bayar_pengangkutan==1">Berbayar</template><template v-else>Subsidi</template>
                           </w-tag>
                        </div>
                     </td>
                     <td width="1%"><b></b></td>
                     <td width="24%" align="right">
                     </td>
                     <td width="31%" align="right">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <!-- <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.pengangkutan" @input="kiraan_caj(datas)" :validators="[validators.required]" outline/> -->
                           <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.pengangkutan_sinkronisasi" @input="kiraan_caj(datas)" outline/>
                        </div>
                        <div v-else>
                          RM {{$zutil.formatDecimal(datas.pengangkutan_sinkronisasi)}}
                        </div>
                     </td>
                  </tr>
                  </tbody>
               </table>
            </div>
            <div class="mx2"></div>
         </div>

         <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table width="100%">
                <tbody>
                  <tr class="row_data">
                     <td width="1%"><b>4.</b></td>
                     <td width="22%"><b>Caj Lain-Lain (Jika Ada) (RM)</b></td>
                     <td width="1%"><b>:</b></td>
                     <td width="20%">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <w-radios
                             :items="ya_tidak"
                             v-model="datas.bayar_caj_lain"
                             @input="kiraan_caj(datas)"
                             inline class="mr2"
                             :validators="[validators.required]"
                             >
                           </w-radios>
                        </div>
                        <div v-else>
                           <w-tag
                             class="mr4"
                             bg-color="primary"
                             round>
                              <template v-if="datas.bayar_caj_lain==1">Berbayar</template><template v-else>Subsidi</template>
                           </w-tag>
                        </div>
                     </td>
                     <td width="1%"><b></b></td>
                     <td width="24%" align="right">
                     </td>
                     <td width="31%" align="right">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <!-- <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.pengangkutan" @input="kiraan_caj(datas)" :validators="[validators.required]" outline/> -->
                           <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.caj_lain_sinkronisa" @input="kiraan_caj(datas)" outline/>
                        </div>
                        <div v-else>
                           RM
                           <template v-if="datas.caj_lain_sinkronisa==null"> -
                           </template>
                           <template v-else>
                           {{$zutil.formatDecimal(datas.caj_lain_sinkronisa)}}
                           </template>
                        </div> 
                     </td>
                  </tr>
                  <tr class="row_data">
                     <td width="1%"><b></b></td>
                     <td width="22%"><b>Nyatakan</b></td>
                     <td width="1%"><b>:</b></td>
                     <td colspan="2">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <template v-if="nyatakan_wajib==true">
                              <z-input style="margin:5px;" label="" class="mt4" v-model="datas.nyatakan_sinkronisa" @input="kiraan_caj(datas)" placeholder="Sila Masukan.." :validators="[validators.required]" outline/>

                           </template>
                           <template v-else>
                              <z-input style="margin:5px;" label="" class="mt4" v-model="datas.nyatakan_sinkronisa" @input="kiraan_caj(datas)" placeholder="Sila Masukan.." outline/>
                           </template>
                        </div>
                        <div v-else>
                            {{datas.nyatakan_sinkronisa}}
                        </div> 
                     </td>
                     <td colspan="2"></td>
                  </tr>
                  </tbody>
               </table>
            </div>
            <div class="mx2"></div>
         </div>

          <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table width="100%">
                <tbody>
                  <tr class="row_data">
                     <td width="23%"><b>Jumlah Caj Keseluruhan</b></td>
                     <td valign="top" width="1%"><b>:</b></td>
                     <td valign="top" width="3%"><b>RM</b></td>
                     <td valign="top" width="18%">
                        <b>{{$zutil.formatDecimal(datas.keseluruhan_sinkronisasi)}}</b>
                     </td>
                     <td width="55%"></td>
                  </tr>
                  <tr class="row_data">
                     <td width="23%"><b>Jumlah Caj Subsidi Kerajaan</b></td>
                     <td valign="top" width="1%"><b>:</b></td>
                     <td valign="top" width="3%"><b>RM</b></td>
                     <td valign="top" width="18%">
                        <b>{{$zutil.formatDecimal(datas.subsidi_sinkronisasi)}}</b>
                     </td>
                     <td width="55%"></td>
                  </tr>
                  <tr class="row_data">
                     <td width="23%"><b>Jumlah Caj Yang Perlu Dibayar</b></td>
                     <td valign="top" width="1%"><b>:</b></td>
                     <td valign="top" width="3%"><b>RM</b></td>
                     <td valign="top" width="18%">
                        <b>{{$zutil.formatDecimal(datas.perlu_bayar_sinkronisasi)}}</b>
                     </td>
                     <td width="55%"></td>
                  </tr>
                  </tbody>
               </table>
            </div>
            <div class="mx2"></div>
         </div>
    </div>
  </w-card>
        <w-flex class="mt3" wrap align-center justify-end v-if="(datas.perkhidmatan!=1 && datas.lkp_status_id==34)||(datas.perkhidmatan==1 && datas.lkp_status_id==27)">
          <w-button class="my1" :loading="loading" :disabled="loading" type="submit">
            <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
          </w-button>
          <!-- <w-button class="my1" :loading="loading" @click="send(2); onSuccess()">
            <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
          </w-button> -->
        </w-flex>
    </w-form>
    <w-dialog
        v-model="dialog.show"
        :fullscreen="dialog.fullscreen"
        :width="dialog.width"
        :persistent="dialog.persistent"
        :persistent-no-animation="dialog.persistentNoAnimation"
        title-class="primary-dark1--bg white">
        <template #title>
          <w-icon class="mr2">fal fa-list</w-icon>
          {{dialog.title}}
        </template>
        <w-form 
         ref="form" 
         v-model="dialog.valid"
         @validate="simpanHormon"
         @success="success"
      >
        <template v-if="datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27">
          <z-select class="mt4" :items="JenisHormon" label="Kaedah Sinkronisasi *"  v-model="form_hormon.lkp_jenis_hormon_id" :validators="[validators.required]"  @input="hargaHormon()"/>
          <template v-if="form_hormon.lkp_jenis_hormon_id == 3">
            <w-input class="mt4" label="Nama Hormon *"  v-model="form_hormon.nama_hormon" :validators="[validators.required]"/>
            <w-input class="mt4" label="Jenis Hormon *"  v-model="form_hormon.jenis_hormon" :validators="[validators.required]"/>
            <w-input class="mt4" label="Tarikh Hormon *" type="date" v-model="form_hormon.tarikh_hormon" :validators="[validators.required]"/>
            <w-input class="mt4" label="Kuantiti (ml) *" type="number"  v-model="form_hormon.kuantiti_hormon" :validators="[validators.required]"/>
               <table >
                <tbody>
                  <tr class="row_data">
                     <td>
                        <z-money class="mt4" label="Harga (RM) *" v-model:originalValue="form_hormon.harga" :validators="[validators.required]" />
                     </td>
                     <td>
                        <w-radios
                             :items="ya_tidak"
                             v-model="form_hormon.sinkronisasi_ya_tidak"
                             inline class="mr2"
                             :validators="[validators.required]"
                             >
                           </w-radios>
                        
                     </td>
                  </tr>
                  </tbody>
               </table>
          </template>
          <template v-else>
            <w-input class="mt4" label="Tarikh Masuk/Suntik *" type="date" v-model="form_hormon.tarikh_masuk_suntik" :validators="[validators.required]"/>
            <w-input class="mt4" label="Tarikh Keluar/Suntik *" type="date" v-model="form_hormon.tarikh_keluar_suntik" :validators="[validators.required]"/>
            

               <table >
                <tbody>
                  <tr class="row_data">
                     <td>
                        <z-money class="mt4" label="Harga (RM) *" v-model:originalValue="form_hormon.harga" :validators="[validators.required]"/>
                     </td>
                     <td>
                        <w-radios
                             :items="ya_tidak"
                             v-model="form_hormon.sinkronisasi_ya_tidak"
                             inline class="mr2"
                             :validators="[validators.required]"
                             >
                           </w-radios>
                        
                     </td>
                  </tr>
                  </tbody>
               </table>
          </template>
        </template>
        <template v-else>
          <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
             <table >
              <tbody>
                <tr class="row_data">
                  <td><b>Kaedah Sinkronisasi</b></td>
                  <td width="10px">:</td>
                  <td>
                    {{form_hormon.hormon}}
                  </td>
                </tr>
                <template v-if="form_hormon.lkp_jenis_hormon_id == 3">
                  <tr class="row_data">
                    <td><b>Nama Hormon</b></td>
                    <td width="10px">:</td>
                    <td>
                      {{form_hormon.nama_hormon}}
                    </td>
                  </tr>
                  <tr class="row_data">
                    <td><b>Jenis Hormon</b></td>
                    <td width="10px">:</td>
                    <td>
                      {{form_hormon.jenis_hormon}}
                    </td>
                  </tr>
                  <tr class="row_data">
                    <td><b>Tarikh Hormon</b></td>
                    <td width="10px">:</td>
                    <td>
                      {{$zutil.dateformat(form_hormon.tarikh_hormon)}}
                    </td>
                  </tr>
                  <tr class="row_data">
                    <td><b>Kuantiti (ml)</b></td>
                    <td width="10px">:</td>
                    <td width="10px">
                      {{form_hormon.kuantiti_hormon}}
                    </td>
                  </tr>
                  <tr class="row_data">
                    <td><b>Harga (RM)</b></td>
                    <td width="10px">:</td>
                    <td width="80px">
                      {{$zutil.formatDecimal(form_hormon.harga)}}
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr class="row_data">
                    <td><b>Tarikh Masuk/Suntik</b></td>
                    <td width="10px">:</td>
                    <td width="80px">
                      {{$zutil.dateformat(form_hormon.tarikh_masuk_suntik)}}
                    </td>
                  </tr>
                  <tr class="row_data">
                    <td><b>Tarikh Keluar/Suntik</b></td>
                    <td width="10px">:</td>
                    <td width="80px">
                      {{$zutil.dateformat(form_hormon.tarikh_keluar_suntik)}}
                    </td>
                  </tr>
                  <tr class="row_data">
                    <td><b>Harga (RM)</b></td>
                    <td width="10px">:</td>
                    <td width="10px">
                      {{$zutil.formatDecimal(form_hormon.harga)}}
                    </td>
                  </tr>
                </template>
                </tbody>
             </table>
            </div>
          </div>
        </template>
        </w-form>
          <template #actions>
            <div class="spacer" />
            <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
            <w-button 
         class="ml1" 
         :loading="dialog.loading"
         :disabled="dialog.valid === false"
         @click="$refs.form.validate()"
         v-if="datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27"
         >
           SIMPAN
         </w-button>
          </template>
      </w-dialog>
  </div>
</template>

<script>
export default {
  name: "Pemilik",
  props:{
    d_data: [Array, Object],
    d_segmenName: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.semakan.sinkronisasi-aiman',
      form : {},
      datas : this.d_data,
      JenisHormon : [],
      loading:false,
      ternakan_sinkronisasi:[],
      list_stock:[],

      skorbadanlist:[
        {value: 1, label: "1"},
        {value: 2, label: "2"},
        {value: 3, label: "3"},
        {value: 4, label: "4"},
        {value: 5, label: "5"}
      ],

      validators: {
          required: (value) => !!value || "Medan ini wajib diisi",
          consent: (value) => !!value || "You must agree",
          email: (value) =>
              !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
              "Sila Semak Format Email",
          numeric: (value) => value !== '' || !isNaN(value) || "Medan Ini Wajib Numeric",
      },
      cidr:{
        jumlah: '',
        harga:0.00,
        sinkronisasi_ya_tidak:'',
        kuantiti: ''
      },
      prid_delta:{
        jumlah: '',
        harga:0.00,
        sinkronisasi_ya_tidak:'',
        kuantiti: ''
      },
      hormon:{
        jumlah: '',
        harga:0.00,
        sinkronisasi_ya_tidak:'',
        kuantiti: ''
      },
      form_hormon : {},
      jumlah_persendirian:0,
      total_harga:0,
      loading:false,
      dialog: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 800,
      },
      isMinimizedList:false,
      isMinimizedCaj:false,
      nyatakan_wajib:false,
      ibvk:[],
      negri:[],
      listStock :[],
      persendirian:[],
      ya_tidak:[
         {value: 1, label: "Berbayar"},
         {value: 2, label: "Subsidi"},
      ],
      
    }
  },
  methods:{

    add(art_butiran_id, dt){
      this.form_hormon = {
              id : 0,
              art_id : '',
              art_butiran_id : art_butiran_id,
              lkp_jenis_hormon_id : '',
              sinkronisasi_ya_tidak : '',
              harga : 0

          }
          
          this.dialog.show = true
          this.dialog.title = 'Tambah'
          this.form.saveButton = "Simpan"
          this.JenisHormon=[];
          this.lkpJenisHormon(dt);
    },
    edit(item, dt){
      this.form_hormon = item
      // alert(this.form_hormon.lkp_jenis_hormon_id)
          
          this.dialog.show = true
          this.dialog.title = 'Kemaskini'
          this.form.saveButton = "Simpan"
          this.lkpJenisHormonEdit(item);
    },
    hargaHormon(){
      for (var b in this.lkp_jenis_hormon) {
          if(this.lkp_jenis_hormon[b].value == this.form_hormon.lkp_jenis_hormon_id){
            this.form_hormon.harga = this.lkp_jenis_hormon[b].harga
          }
      }
    },

    remove(item){
      this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              this.$zcomm.delete('art.semakan.sinkronisasi-aiman.destroy', item.id)
              .then(res => {
                this.$zutil.notify ("Rekod telah berjaya dipadam")
                this.getData();
                if (typeof this.onAfterDelete === "function") {
                  this.onAfterDelete()
                }
              })
              .finally(() => {
                // $('#' + this.resourceurl).modal('hide')
              });
            }
          });
    },
    simpanHormon(){
      if (!this.loading) {
      let isValid = true;
      this.loading=true;
      if (!this.form_hormon.lkp_jenis_hormon_id) {
        isValid = false;
        this.loading=false;
      }else if (
        // this.form_hormon.lkp_jenis_hormon_id == 3 && !this.form_hormon.nama_hormon && !this.form_hormon.jenis_hormon && !this.form_hormon.tarikh_hormon && !this.form_hormon.kuantiti_hormon && !this.form_hormon.harga && !this.form_hormon.sinkronisasi_ya_tidak
            this.form_hormon.lkp_jenis_hormon_id == 3 &&
              (
                !this.form_hormon.nama_hormon ||
                !this.form_hormon.jenis_hormon ||
                !this.form_hormon.tarikh_hormon ||
                !this.form_hormon.kuantiti_hormon ||
                // !this.form_hormon.harga ||
                !this.form_hormon.sinkronisasi_ya_tidak
              )
      ){
        isValid = false;
        this.loading=false;
      }else if(
            // this.form_hormon.lkp_jenis_hormon_id != 3 && !this.form_hormon.tarikh_masuk_suntik && !this.form_hormon.tarikh_keluar_suntik
        this.form_hormon.lkp_jenis_hormon_id != 3 &&
          (
            !this.form_hormon.tarikh_masuk_suntik ||
            !this.form_hormon.tarikh_keluar_suntik ||
            // !this.form_hormon.harga ||
            !this.form_hormon.sinkronisasi_ya_tidak
          )
      ){
        isValid = false;
        this.loading=false;
      }
      if (!isValid) 
      {
        this.$zutil.notify("Pastikan semua data sudah diisi", false);
        this.loading=false;
        return false;
      }
      this.$zcomm.post('art.semakan.sinkronisasi-aiman.store', this.form_hormon).then(res => {
        if (typeof this.onAfterAdd === "function") {
          this.onAfterAdd()
        }
        this.$zutil.notify ("Rekod telah berjaya disimpan");
        this.loading=false;
        this.dialog.show = false
        this.getData()
        this.kiraan_caj()
      })
      }
    },
    kiraan_caj(){
      var cidr_kuantiti=0;
      var cidr_harga=0;
      var cidr_jumlah=0;
      var cidr_sinkronisasi_ya_tidak =0;

      var prid_delta_kuantiti=0;
      var prid_delta_harga=0;
      var prid_delta_jumlah=0;
      var prid_delta_sinkronisasi_ya_tidak =0;

      // var hormon_kuantiti=0;
      // var hormon_harga=0;
      // var hormon_jumlah=0;
      // var hormon_sinkronisasi_ya_tidak =0;

      var total_harga = 0;
      var jumlah_persendirian = 0;

      var harga_persendirian_subsidi = 0;
      var harga_persendirian_bayar = 0;
      var jumlah_persendirian_subsidi = 0;
      var jumlah_persendirian_bayar = 0;
      var kuantiti_persendirian_bayar = 0;
      var kuantiti_persendirian_subsidi = 0;
      var sinkronisasi_ya_tidak_bayar = 0;
      var sinkronisasi_ya_tidak_subsidi = 0;


       for (var b in this.ternakan_sinkronisasi){
        for (var a in this.ternakan_sinkronisasi[b].sinkronisasi){
          if(this.ternakan_sinkronisasi[b].sinkronisasi[a].lkp_jenis_hormon_id == 1){

            // if(this.ternakan_sinkronisasi[b].sinkronisasi[a].sinkronisasi_ya_tidak == 1){
               cidr_kuantiti=cidr_kuantiti+1;
               cidr_harga = this.ternakan_sinkronisasi[b].sinkronisasi[a].harga;
               cidr_sinkronisasi_ya_tidak = this.ternakan_sinkronisasi[b].sinkronisasi[a].sinkronisasi_ya_tidak;
            // }
          }
          if(this.ternakan_sinkronisasi[b].sinkronisasi[a].lkp_jenis_hormon_id == 2){
            prid_delta_kuantiti= prid_delta_kuantiti+1;
            prid_delta_harga = this.ternakan_sinkronisasi[b].sinkronisasi[a].harga;
            prid_delta_sinkronisasi_ya_tidak = this.ternakan_sinkronisasi[b].sinkronisasi[a].sinkronisasi_ya_tidak;
          }
          if(this.ternakan_sinkronisasi[b].sinkronisasi[a].lkp_jenis_hormon_id == 3){

           if(this.ternakan_sinkronisasi[b].sinkronisasi[a].sinkronisasi_ya_tidak == 2){
               jumlah_persendirian_subsidi = jumlah_persendirian_subsidi+ Number(this.ternakan_sinkronisasi[b].sinkronisasi[a].harga);
               harga_persendirian_subsidi = harga_persendirian_subsidi+ Number(this.ternakan_sinkronisasi[b].sinkronisasi[a].harga);
               kuantiti_persendirian_subsidi = this.ternakan_sinkronisasi[b].sinkronisasi[a].kuantiti_hormon;
               sinkronisasi_ya_tidak_subsidi = this.ternakan_sinkronisasi[b].sinkronisasi[a].sinkronisasi_ya_tidak;
            }else{
               jumlah_persendirian_bayar = jumlah_persendirian_bayar+ Number(this.ternakan_sinkronisasi[b].sinkronisasi[a].harga); 
                harga_persendirian_bayar = harga_persendirian_bayar+ Number(this.ternakan_sinkronisasi[b].sinkronisasi[a].harga);
               kuantiti_persendirian_bayar = this.ternakan_sinkronisasi[b].sinkronisasi[a].kuantiti_hormon;
               sinkronisasi_ya_tidak_bayar = this.ternakan_sinkronisasi[b].sinkronisasi[a].sinkronisasi_ya_tidak;
            }
            jumlah_persendirian = jumlah_persendirian+ Number(this.ternakan_sinkronisasi[b].sinkronisasi[a].harga);
          }

        }
       }
      this.cidr.jumlah = cidr_harga * cidr_kuantiti;
      this.cidr.harga = cidr_harga;
      this.cidr.kuantiti = cidr_kuantiti;
      this.cidr.sinkronisasi_ya_tidak = cidr_sinkronisasi_ya_tidak;

      this.prid_delta.jumlah = prid_delta_harga * prid_delta_kuantiti;
      this.prid_delta.harga = prid_delta_harga;
      this.prid_delta.kuantiti = prid_delta_kuantiti;
      this.prid_delta.sinkronisasi_ya_tidak = prid_delta_sinkronisasi_ya_tidak;

      

      this.jumlah_persendirian = jumlah_persendirian;

      this.jumlah_persendirian_subsidi = jumlah_persendirian_subsidi;
      this.harga_persendirian_subsidi = harga_persendirian_subsidi;
      this.kuantiti_persendirian_subsidi = kuantiti_persendirian_subsidi;
      this.sinkronisasi_ya_tidak_subsidi = sinkronisasi_ya_tidak_subsidi;

      this.jumlah_persendirian_bayar = jumlah_persendirian_bayar;
      this.harga_persendirian_bayar = harga_persendirian_bayar;
      this.kuantiti_persendirian_bayar = kuantiti_persendirian_bayar;
      this.sinkronisasi_ya_tidak_bayar = sinkronisasi_ya_tidak_bayar;

      this.datas.keseluruhan_sinkronisasi = Number(this.datas.pengangkutan_sinkronisasi) + Number(this.datas.konsutasi_sinkronisasi) + Number(this.datas.caj_lain_sinkronisa) + this.cidr.jumlah +  this.prid_delta.jumlah + this.jumlah_persendirian;

      if(this.datas.jenis_pengguna_pemohon == 1){
      //caj kerajaan
        //  if(this.datas.konsutasi_sinkronisasi_ya_tidak==2){ 
        //        total_harga =  this.cidr.jumlah +  this.prid_delta.jumlah + this.jumlah_persendirian + Number(this.datas.konsutasi_sinkronisasi) + Number(this.datas.caj_lain_sinkronisa) + Number(this.datas.pengangkutan_sinkronisasi);
        //        this.total_harga = total_harga;
        //        this.datas.subsidi_sinkronisasi = total_harga;
        //  }else{
        //      total_harga =  this.cidr.jumlah +  this.prid_delta.jumlah + this.jumlah_persendirian + Number(this.datas.caj_lain_sinkronisa) + Number(this.datas.pengangkutan_sinkronisasi);
        //      this.total_harga = total_harga;
        //      this.datas.subsidi_sinkronisasi = total_harga;
        //  }
        // this.datas.perlu_bayar_sinkronisasi = Number(this.datas.keseluruhan_sinkronisasi) - Number(this.datas.subsidi_sinkronisasi);
         
           if(this.datas.konsutasi_sinkronisasi_ya_tidak==2){ 
             total_harga =  Number(this.datas.konsutasi_sinkronisasi);
             this.total_harga = total_harga;
             // total_harga =  this.cidr.jumlah + this.prid_delta.jumlah + this.jumlah_persendirian + Number(this.datas.konsutasi_sinkronisasi);
             // this.total_harga = total_harga;
             // this.datas.subsidi_sinkronisasi = total_harga;
           }else{
            total_harga =  0;
             this.total_harga = total_harga;
             // total_harga =  this.cidr.jumlah +  this.prid_delta.jumlah + this.jumlah_persendirian;
             // this.total_harga = total_harga;
             // this.datas.subsidi_sinkronisasi = total_harga;
           }

         if(this.cidr.sinkronisasi_ya_tidak ==2){ 
             var subsidi_cidr =  Number(this.cidr.jumlah) ;
         }else{
            var subsidi_cidr = 0;
         }

         if(this.prid_delta.sinkronisasi_ya_tidak ==2){ 
             var subsidi_prid_delta =  Number(this.prid_delta.jumlah) ;
         }else{
            var subsidi_prid_delta = 0;
         }

         

         if(this.datas.bayar_pengangkutan==2){ 
             var pengangkutan_sinkronisasi =  Number(this.datas.pengangkutan_sinkronisasi) ;
         }else{
            var pengangkutan_sinkronisasi = 0;
         }

         if(this.datas.bayar_caj_lain==2){ 
             var caj_lain_sinkronisa =  Number(this.datas.caj_lain_sinkronisa) ;
         }else{
            var caj_lain_sinkronisa = 0;
         }

         // this.subsidi_hormon = subsidi_hormon;
          // this.datas.keseluruhan_sinkronisasi = Number(this.datas.pengangkutan_sinkronisasi) + Number(this.datas.konsutasi_sinkronisasi) + total_harga ;
          // this.datas.perlu_bayar_sinkronisasi = Number(this.datas.pengangkutan_sinkronisasi) + Number(this.datas.konsutasi_sinkronisasi);
           this.datas.subsidi_sinkronisasi = this.total_harga + pengangkutan_sinkronisasi + caj_lain_sinkronisa + subsidi_cidr + subsidi_prid_delta + harga_persendirian_subsidi;

           this.datas.perlu_bayar_sinkronisasi = this.datas.keseluruhan_sinkronisasi - this.datas.subsidi_sinkronisasi;

      }else{//caj swasta
           if(this.datas.konsutasi_sinkronisasi_ya_tidak==2){ 
             total_harga =  Number(this.datas.konsutasi_sinkronisasi);
             this.total_harga = total_harga;
             // total_harga =  this.cidr.jumlah + this.prid_delta.jumlah + this.jumlah_persendirian + Number(this.datas.konsutasi_sinkronisasi);
             // this.total_harga = total_harga;
             // this.datas.subsidi_sinkronisasi = total_harga;
           }else{
            total_harga =  0;
             this.total_harga = total_harga;
             // total_harga =  this.cidr.jumlah +  this.prid_delta.jumlah + this.jumlah_persendirian;
             // this.total_harga = total_harga;
             // this.datas.subsidi_sinkronisasi = total_harga;
           }

         if(this.cidr.sinkronisasi_ya_tidak ==2){ 
             var subsidi_cidr =  Number(this.cidr.jumlah) ;
         }else{
            var subsidi_cidr = 0;
         }

         if(this.prid_delta.sinkronisasi_ya_tidak ==2){ 
             var subsidi_prid_delta =  Number(this.prid_delta.jumlah) ;
         }else{
            var subsidi_prid_delta = 0;
         }

         

         if(this.datas.bayar_pengangkutan==2){ 
             var pengangkutan_sinkronisasi =  Number(this.datas.pengangkutan_sinkronisasi) ;
         }else{
            var pengangkutan_sinkronisasi = 0;
         }

         if(this.datas.bayar_caj_lain==2){ 
             var caj_lain_sinkronisa =  Number(this.datas.caj_lain_sinkronisa) ;
         }else{
            var caj_lain_sinkronisa = 0;
         }

         // this.subsidi_hormon = subsidi_hormon;
          // this.datas.keseluruhan_sinkronisasi = Number(this.datas.pengangkutan_sinkronisasi) + Number(this.datas.konsutasi_sinkronisasi) + total_harga ;
          // this.datas.perlu_bayar_sinkronisasi = Number(this.datas.pengangkutan_sinkronisasi) + Number(this.datas.konsutasi_sinkronisasi);
           this.datas.subsidi_sinkronisasi = this.total_harga + pengangkutan_sinkronisasi + caj_lain_sinkronisa + subsidi_cidr + subsidi_prid_delta + harga_persendirian_subsidi;

           this.datas.perlu_bayar_sinkronisasi = this.datas.keseluruhan_sinkronisasi - this.datas.subsidi_sinkronisasi;
      }
      // console.log(datas.perlu_bayar)
    },
    lkpJenisHormon(dt)
    {

      let lkp_jenis_hormon_id = 0;
      for (var b in dt.sinkronisasi){
        if (dt.sinkronisasi[b].lkp_jenis_hormon_id) {
          lkp_jenis_hormon_id = dt.sinkronisasi[b].lkp_jenis_hormon_id;
          break;
        }
      }
      this.JenisHormon=[];
      if(lkp_jenis_hormon_id == 3){
        this.$zcomm.get(this.api_service + 'lookup/jenis_hormon', {}).then(res => {
          const filteredItems = res.filter(item => item.value == 3 && lkp_jenis_hormon_id == 3);
          for (var i in filteredItems) {
              this.JenisHormon.push({
                value : filteredItems[i].value,
                label : filteredItems[i].label,
                harga : filteredItems[i].harga,
              })
          }
        })
      }else if(lkp_jenis_hormon_id == 1 || lkp_jenis_hormon_id == 2){
        this.$zcomm.get(this.api_service + 'lookup/jenis_hormon', {}).then(res => {
          const filteredItems = res.filter(item => item.value == 3);
          for (var i in filteredItems) {
              this.JenisHormon.push({
                value : filteredItems[i].value,
                label : filteredItems[i].label,
                harga : filteredItems[i].harga,
              })
          }
        })
      }else{
        this.$zcomm.get(this.api_service + 'lookup/jenis_hormon', {}).then(res => {
          const filteredItems = res;
          for (var i in filteredItems) {
              this.JenisHormon.push({
                value : filteredItems[i].value,
                label : filteredItems[i].label,
                harga : filteredItems[i].harga,
              })
          }
        })
      }
        
    },

    lkpJenisHormonEdit(dt)
    {
      
      this.JenisHormon=[];
      if(dt.lkp_jenis_hormon_id == 3){
         this.$zcomm.get(this.api_service + 'lookup/jenis_hormon', {}).then(res => {
            this.JenisHormon = res.filter(item => item.value == 3);
          
         })
      }else if(dt.lkp_jenis_hormon_id == 1 || dt.lkp_jenis_hormon_id == 2){

         this.$zcomm.get(this.api_service + 'lookup/jenis_hormon', {}).then(res => {
            this.JenisHormon = res
          
         })
      }else{
         this.$zcomm.get(this.api_service + 'lookup/jenis_hormon', {}).then(res => {
             this.JenisHormon = res
         })
      }
    },
    lookupStock()
    {
      this.$zcomm.get(this.api_service + 'lookup/stock/1', {}).then(res => {
        this.list_stock = res
      })
    },
    getHarga(dt){
      for (var b in this.list_stock) {
        if(this.list_stock[b].value==dt.se_stock_id){
          dt.harga_straw = this.list_stock[b].harga;
          dt.max_kuantiti_straw = this.list_stock[b].baki;
        }
      }
    },
    cekBakiStraw(dt){
      if(dt.bil_straw > dt.max_kuantiti_straw){
        dt.bil_straw = dt.max_kuantiti_straw;
      }
    },

    getData(){
      this.ternakan_sinkronisasi = []
      this.$zcomm.get(this.api_service + 'art/show/'+this.datas.id, {}).then(res => {

        for (var b in res.ternakan_list) {
          if(res.ternakan_list[b].bunting==2 && res.ternakan_list[b].status_pemeriksaan ==1){
            // this.getHarga(this.datas.ternakan_list[b]);
            this.ternakan_sinkronisasi.push({
              id : res.ternakan_list[b].id,
              art_id : res.ternakan_list[b].art_id,
              harga :res.ternakan_list[b].harga_sinkronisasi,
              ternakan_nama : res.ternakan_list[b].ternakan_nama,
              sinkronisasi : res.ternakan_list[b].sinkronisasi
            })
          }
        }
        this.kiraan_caj();

      });
    },
    getTernakan(){
      // ternakan list
      for (var b in this.datas.ternakan_list) {
        if(this.datas.ternakan_list[b].bunting==2 && this.datas.ternakan_list[b].status_pemeriksaan ==1){
          // this.getHarga(this.datas.ternakan_list[b]);
          this.ternakan_sinkronisasi.push({
            id:this.datas.ternakan_list[b].id,
            art_id:this.datas.ternakan_list[b].art_id,
            harga:this.datas.ternakan_list[b].harga_sinkronisasi,
            ternakan_nama:this.datas.ternakan_list[b].ternakan_nama,
            sinkronisasi : this.datas.ternakan_list[b].sinkronisasi
          })
        }
      }
      this.kiraan_caj();
    },

    //belum benar
    bilanganInseminasi() {
      const tarikh_pemeriksaan = new Date(this.datas.tarikh_pemeriksaan);
      const tarikh_sekarang = new Date();

      const batasTanggal = new Date(tarikh_sekarang);
      batasTanggal.setMonth(batasTanggal.getMonth() + 3);
      if(tarikh_pemeriksaan == tarikh_sekarang){
        return 1;
      }else if(tarikh_pemeriksaan > tarikh_sekarang && tarikh_pemeriksaan <= batasTanggal){
        return 2;
      }else if(tarikh_pemeriksaan > batasTanggal){
         return 3;
      }
      return 1;
      // return formattedDate;
    },

    jankaanBiangSemula(tarikh){
      const tarikh_pemeriksaan = new Date(this.datas.tarikh_pemeriksaan);
      tarikh_pemeriksaan.setDate(tarikh_pemeriksaan.getDate() + this.datas.ternakan_biang_semula); //tambah  hari untuk lembu
      const formattedDate = `${tarikh_pemeriksaan.getFullYear()}-${String(tarikh_pemeriksaan.getMonth() + 1).padStart(2, '0')}-${String(tarikh_pemeriksaan.getDate()).padStart(2, '0')}`;
      return formattedDate;
    },

    validateForm() {
      this.loading=true;
      let isValid = true;
      console.log(this.ternakan_sinkronisasi)
      // if (this.datas.lkp_status_id==34) {
        this.ternakan_sinkronisasi.forEach((row) => {
          // if (!row.tarikh_masuk_suntik || !row.lkp_jenis_hormon_id || !row.nama_hormon_1 || !row.jenis_hormon_1 || !row.tarikh_hormon_1 || !row.kuantiti_hormon_1 || !row.harga_hormon_1) {
          //   isValid = false;
          //   this.loading=false;
          // }

        if (!this.datas.konsutasi_sinkronisasi_ya_tidak || !this.datas.bayar_pengangkutan || !this.datas.bayar_caj_lain) {
            isValid = false;
            this.loading=false;
        }
            

          if(row.lkp_jenis_hormon_id === 1 || row.lkp_jenis_hormon_id === 2){
            if (!row.tarikh_masuk_suntik || !row.lkp_jenis_hormon_id || !row.tarikh_keluar_suntik || !row.harga) {
              isValid = false;
              this.loading=false;
            }
          }
        });
      // }

      if (!isValid) {
        this.$zutil.notify("Pastikan semua data sudah diisi", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.onSuccess();
    },
    send(hantar){
      this.datas.hantar = hantar
    },

    onSuccess(){
      this.loading=true;
      if(this.datas.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.datas.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.datas.id, {ternakan_sinkronisasi:this.ternakan_sinkronisasi, prosedur:1, hantar:1})
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  this.loading=false;
                  if (this.form.hantar==1) {
                      // this.$inertia.visit(this.$route('art.permohonan.show', this.datas.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                      this.$inertia.visit(this.$route('art.semakan.sinkronisasi-aiman',this.datas.id)+'?tab=2');
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }
            }else{
              this.loading=false;
            }
          })
      }else{
        if (this.datas.id > 0) 
        {
           var param = {
            ternakan_sinkronisasi: this.ternakan_sinkronisasi,
            prosedur: 1,
            subsidi_sinkronisasi: this.datas.subsidi_sinkronisasi,
            keseluruhan_sinkronisasi: this.datas.keseluruhan_sinkronisasi,
            perlu_bayar_sinkronisasi: this.datas.perlu_bayar_sinkronisasi,
            pengangkutan_sinkronisasi:this.datas.pengangkutan_sinkronisasi,
            konsutasi_sinkronisasi: this.datas.konsutasi_sinkronisasi,
            konsutasi_sinkronisasi_ya_tidak: this.datas.konsutasi_sinkronisasi_ya_tidak,
            bayar_pengangkutan: this.datas.bayar_pengangkutan,
            bayar_caj_lain: this.datas.bayar_caj_lain,
            caj_lain_sinkronisa: this.datas.caj_lain_sinkronisa,
            nyatakan_sinkronisa: this.datas.nyatakan_sinkronisa
          }

          // this.$zcomm.post(window.route('keputusan.pbd.pbd.update_keputusan', pbd_mp.id), param)
          this.$zcomm.update(this.resourceurl + '.update', this.datas.id, param)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            this.loading=false;
            if (this.form.hantar==1) {
                // this.$inertia.visit(this.$route('art.permohonan.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
              this.$inertia.visit(this.$route('art.semakan.sinkronisasi-aiman',this.datas.id)+'?tab=2');
                // this.$inertia.visit(this.$route('art.sinkronisasi_ai.show', this.datas.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
      } 
      
    },
  },
      
  mounted() {
    this.getTernakan();
    this.lookupStock()
    // this.datas = this.data;
  }
}
      

</script>  
<style type="text/css">

/*.w-table__row {
  display: flex;
  align-items: center;
}*/
.w-table__cell {
  vertical-align: middle;
}

</style>
